<div class="social-wall-reply">
  <div class="social-wall-reply__main">
    <lib-user-avatar [size]="32" [user]="reply().author"></lib-user-avatar>

    <div class="social-wall-reply__body">
      <div class="social-wall-reply__header">
        <div class="social-wall-reply__name">{{ reply().author?.formattedProfileName }}</div>
        @if (reply().author?.role) {
          <div class="social-wall-reply__role">{{ reply().author.role }}</div>
        }
      </div>

      <div class="social-wall-reply__time">{{ reply().created | timeElapsed }}</div>

      <div class="social-wall-reply__content" [innerHtml]="reply().message"></div>

      <div class="social-wall-reply__footer">
        <button
          type="button"
          class="social-wall-reply__action"
          data-cy="social-wall-reply-like"
          (click)="like.emit(reply())">
          <lib-icon icon="heart" [size]="20" [fill]="!!reply().userLiked"></lib-icon>
          {{ reply().totalLikes || 0 }}
        </button>

        @if (allowReply()) {
          <button
            type="button"
            class="social-wall-reply__action"
            data-cy="social-wall-reply-reply"
            (click)="replyTo.emit(reply())">
            {{ 'FORUM.reply' | translate }}
          </button>
        }

        @if (canExpand()) {
          <button
            type="button"
            class="social-wall-reply__action social-wall-reply__action--replies"
            data-cy="social-wall-reply-toggle-replies"
            (click)="toggleReplies()">
            {{ (expanded() ? 'SOCIAL_WALL.hide_replies' : 'SOCIAL_WALL.show_replies') | translate:{ count: repliesCount() } }}
          </button>
        }
      </div>
    </div>
  </div>

  @if (expanded()) {
    <div class="social-wall-reply__children">
      @for (child of childReplies(); track child.id || $index) {
        <lib-social-wall-reply
          [reply]="child"
          [level]="level() + 1"
          (like)="like.emit($event)"
          (replyTo)="replyTo.emit($event)"
          (loadReplies)="loadReplies.emit($event)">
        </lib-social-wall-reply>
      }
    </div>
  }
</div>
